export default __webpack_public_path__ + "static/media/mikolaj-DCzpr09cTXY-unsplash.3cb7f59f.jpg";